import crypto from 'crypto-js';

const encrryptData = (data) => {
  const hash = crypto.SHA256(data).toString();
  return hash;
};

export default encrryptData;
